export default function HeroSection() {
  return (
    <section
      id="header"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0a0a]"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/4ec87f934d89e1ff7a008b82673931c1.jpg)",
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#0a0a0a]" />

      {/* Decorative accent line */}
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-px h-40 bg-gradient-to-b from-transparent to-[#C9A85C]/60" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 text-center">
        <p className="text-[#C9A85C] text-xs tracking-[5px] uppercase mb-6 font-medium">
          iOS App Development
        </p>
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-[0.95] mb-6 tracking-tight">
          Crafting Premium
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#C9A85C] to-[#E8D5A3]">
            iOS Experiences
          </span>
        </h1>
        <p className="text-white/60 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mt-8">
          KOMAS DOO is a team of experts dedicated to building modern,
          high-performance applications that enhance security and elevate the
          mobile experience.
        </p>

        {/* Scroll indicator */}
        <div className="mt-20 flex flex-col items-center gap-2 animate-bounce">
          <div className="w-px h-12 bg-gradient-to-b from-[#C9A85C]/60 to-transparent" />
          <span className="text-white/30 text-xs tracking-[3px] uppercase">Scroll</span>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
    </section>
  );
}
